import logo from '../logo.svg';
import '../css/App.css';
import SignIn from './SignIn';
import TopBar from './TopBar';
import 'bootstrap/dist/css/bootstrap.min.css';
import Layout from './Layout';
import LandingPage from './LandingPage'
import Firebase, {auth} from './Firebase';
import {useAuthState} from 'react-firebase-hooks/auth';
import CalendarView from './CalendarView'
import SideBar from './SideBar.js'
import { Container } from 'react-bootstrap';
import React from 'react'



//import Name from './Name';
function App() {
  const [user] = useAuthState(auth);
  const [activePage, setActivePage] = React.useState('home')
  return (

    
    <div className="App">
      <TopBar /> 
         {/* <Name /> */}
       
         <LandingPage />


         {
          user && ( <><SideBar setActivePage = {setActivePage}/>
                    {
                      (activePage =="home")? <Layout /> :<CalendarView/>
                    }
             
                  </> )
         }

         


        
      
    </div>
  );
}

export default App;
